module.exports = __webpack_public_path__ + "static/img/bg9.1d477a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/bg9.jpg
// module id = bEd9
// module chunks = 155